import { c as _c } from "react/compiler-runtime";
import useCartFinancials from '@/contexts/cartContext/hooks/useCartFinancials';
import useCartMainButton from '@/contexts/cartContext/hooks/useCartMainButton';
import useCartReservationInProgress from '@/contexts/cartContext/hooks/useCartReservationInProgress';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import usePageFormErrors from '@/contexts/pageContext/hooks/usePageFormErrors';
import { FFormIdEnum } from '@/types/form';
import { FGTMEventEnum } from '@/types/gtm';
import { BPaymentBehaviourEnum } from '@/types/temp';
import getGTMECommerce from '@/utils/gtm/getGTMECommerce';
import pushGTMDataLayer from '@/utils/gtm/pushGTMDataLayer';
import { Error, Loader } from '@winelidays/wld-tsx-2/elements';
import { Suspense, useEffect } from 'react';
import BookingSticky from '../components/BookingSticky';
import TunnelTemplate from '../components/TunnelTemplate';
import useTunnelBookingType from '../context/hooks/useTunnelBookingType';
import useTunnelExperience from '../context/hooks/useTunnelExperience';
import CartMainButton from './components/CartMainButton';
import ContactInfoForm from './ContactInfoForm';
import DiscountCodeForm from './DiscountCodeForm';
import ValidationInfo from './OptinsAndInfo/ValidationInfo';
import ValidationOptIns from './OptinsAndInfo/ValidationOptIns';
import PaymentForm from './PaymentForm';
import SpecialRequestForm from './SpecialRequestForm';
const ValidationPage = () => {
    const $ = _c(38);
    const translate = useTranslate();
    const { _key: currencyKey } = useCurrency();
    const { mainButtonLabel } = useCartMainButton();
    const { showFormErrors } = usePageFormErrors(FFormIdEnum.CART_VALIDATION);
    const { experience } = useTunnelExperience();
    const reservationInProgress = useCartReservationInProgress();
    const bookingType = useTunnelBookingType();
    const { paymentBehaviour, totalPrice, conversionAmount, discount } = useCartFinancials();
    let t0;
    if ($[0] !== paymentBehaviour) {
        t0 = paymentBehaviour?.includes(BPaymentBehaviourEnum.Checkout) || paymentBehaviour?.includes(BPaymentBehaviourEnum.TakeBankImprint);
        $[0] = paymentBehaviour;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const hasPayment = t0;
    let t1;
    if ($[2] !== translate) {
        t1 = translate("validation_page.globale_form_errors_message");
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const globalFormErrorMessage = t1;
    let t2;
    let t3;
    if ($[4] !== bookingType || $[5] !== conversionAmount || $[6] !== currencyKey || $[7] !== discount || $[8] !== experience || $[9] !== paymentBehaviour || $[10] !== reservationInProgress || $[11] !== totalPrice) {
        t2 = () => {
            if (totalPrice != null) {
                setTimeout(() => {
                    const newDataLayer = getGTMECommerce({
                        bookingType,
                        conversionAmount,
                        currencyKey,
                        discount,
                        experience,
                        paymentBehaviour,
                        reservationInProgress,
                        totalPrice
                    });
                    pushGTMDataLayer({
                        ...newDataLayer,
                        event: FGTMEventEnum.validation
                    });
                }, 100);
            }
        };
        t3 = [bookingType, conversionAmount, currencyKey, discount, experience, paymentBehaviour, reservationInProgress, totalPrice];
        $[4] = bookingType;
        $[5] = conversionAmount;
        $[6] = currencyKey;
        $[7] = discount;
        $[8] = experience;
        $[9] = paymentBehaviour;
        $[10] = reservationInProgress;
        $[11] = totalPrice;
        $[12] = t2;
        $[13] = t3;
    }
    else {
        t2 = $[12];
        t3 = $[13];
    }
    useEffect(t2, t3);
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <BookingSticky showCancellation={true}/>;
        $[14] = t4;
    }
    else {
        t4 = $[14];
    }
    let t5;
    let t6;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <ContactInfoForm />;
        t6 = <DiscountCodeForm />;
        $[15] = t5;
        $[16] = t6;
    }
    else {
        t5 = $[15];
        t6 = $[16];
    }
    let t7;
    if ($[17] !== hasPayment) {
        t7 = hasPayment ? <PaymentForm /> : null;
        $[17] = hasPayment;
        $[18] = t7;
    }
    else {
        t7 = $[18];
    }
    let t8;
    if ($[19] !== t7) {
        t8 = <TunnelTemplate stickyContent={t4} loading={false} className="!mb-0">{t5}{t6}{t7}</TunnelTemplate>;
        $[19] = t7;
        $[20] = t8;
    }
    else {
        t8 = $[20];
    }
    let t10;
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = <SpecialRequestForm />;
        t10 = <ValidationOptIns />;
        $[21] = t10;
        $[22] = t9;
    }
    else {
        t10 = $[21];
        t9 = $[22];
    }
    let t11;
    if ($[23] !== mainButtonLabel) {
        t11 = <ValidationInfo buttonLabel={mainButtonLabel}/>;
        $[23] = mainButtonLabel;
        $[24] = t11;
    }
    else {
        t11 = $[24];
    }
    let t12;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = <Loader />;
        $[25] = t12;
    }
    else {
        t12 = $[25];
    }
    let t13;
    if ($[26] !== globalFormErrorMessage || $[27] !== showFormErrors) {
        t13 = showFormErrors ? <Error>{globalFormErrorMessage}</Error> : null;
        $[26] = globalFormErrorMessage;
        $[27] = showFormErrors;
        $[28] = t13;
    }
    else {
        t13 = $[28];
    }
    let t14;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = <CartMainButton />;
        $[29] = t14;
    }
    else {
        t14 = $[29];
    }
    let t15;
    if ($[30] !== t13) {
        t15 = <div className="w-full flex flex-col items-center mt-4 mb-6"><Suspense fallback={t12}>{t13}{t14}</Suspense></div>;
        $[30] = t13;
        $[31] = t15;
    }
    else {
        t15 = $[31];
    }
    let t16;
    if ($[32] !== t11 || $[33] !== t15) {
        t16 = <div className="w-full">{t9}{t10}{t11}{t15}</div>;
        $[32] = t11;
        $[33] = t15;
        $[34] = t16;
    }
    else {
        t16 = $[34];
    }
    let t17;
    if ($[35] !== t16 || $[36] !== t8) {
        t17 = <>{t8}{t16}</>;
        $[35] = t16;
        $[36] = t8;
        $[37] = t17;
    }
    else {
        t17 = $[37];
    }
    return t17;
};
export default ValidationPage;
